import { render, staticRenderFns } from "./GenInspectPage.vue?vue&type=template&id=b890d5a6"
import script from "./GenInspectPage.vue?vue&type=script&lang=js"
export * from "./GenInspectPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports